module.exports = __webpack_public_path__ + "img/stationmanage.4c02291c.png";